// Dropdown click event
document.querySelectorAll('.dropdown__heading').forEach((element, index) => {
  // Find the div for the content
  const dropdownContent = element.parentElement.querySelector('.dropdown__content');
  const dropdownContentContainer = element.parentElement.querySelector('.dropdown__content-container');
  element.addEventListener('click', function () {
    // initialize height of the parent, 0 when it's closed
    let initial_height = 0;

    // check si le dropdown est ouvert
    if (dropdownContent.classList.contains('dropdown__content--visible')) {
      // enleve les class et donne la taille initial
      dropdownContentContainer.style.height = initial_height + "px";
      element.classList.toggle('dropdown__heading--active');
      element.parentElement.querySelector('.dropdown__content').classList.toggle('dropdown__content--visible');
    } else {
      // si element ne contient pas active ferme tous les autres élements, on passe cette boucle si on clique sur le meme dropdown pour faire un simple toggle
      let active = document.querySelector('.dropdown__heading.dropdown__heading--active');
      if (active != null) {
        active.classList.remove('dropdown__heading--active');
        active.parentElement.querySelector('.dropdown__content').classList.remove('dropdown__content--visible');
        active.parentElement.querySelector('.dropdown__content-container').style.height = initial_height + "px";
      }

      // ajout des class et donne la taille finale
      let final_height = 0 + dropdownContent.clientHeight;
      dropdownContentContainer.style.height = final_height + "px";
      element.classList.toggle('dropdown__heading--active');
      element.parentElement.querySelector('.dropdown__content').classList.toggle('dropdown__content--visible');
    }
  });
});

// au chargement de la page calcul du dropdown ouvert s'il y en a un pour permettre la transition de fermeture
window.addEventListener("load", function () {
  const dropdownOpen = document.querySelector('.dropdown__content--visible');
  if (dropdownOpen != null) {
    dropdownOpen.closest(".dropdown__content-container").style.height = dropdownOpen.clientHeight + 'px';
  }
});